import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import API from "../../api/api";


const callApi = async (endpoint) => {
  try {
    const response = await API.get(endpoint);
    if (response.status === 200) {
      return response?.data?.data;
    } else {
      return response?.data?.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const patchApi = async (endpoint, body) => {
  try {
    const response = await API.patch(endpoint, body);
    if (response.status === 200) {
      return response?.data?.data;
    } else {
      return response?.data?.data;
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

const DashboardService = {
  dashboardTiles: async () => {
    return callApi("dashboard-tiles");
  },
  dashboardProfile: async () => {
    return callApi("dashboard-user-profile");
  },
  appLayout: async () => {
    return callApi("app-layout");
  },
  getGraph: async (params) => {
    return callApi(`get-graph?timeFrame=${params}`);
  },
  multiCurrencyUpdation: async (body) => {
    return patchApi(`change-currency`, body);
  },
  multiLanguageUpdation: async (body) => {
    return patchApi(`change-language`, body);
  },
  notificationCall: async () => {
    return callApi('notifications');
  },
  ReadAllNotification: async () => {
    return API.post(`notifications-read-all`);
  },
  dashboardDetails: async () => {
    return callApi("dashboard-details");
  },
  topRecruiters: async () => {
    return callApi("top-recruiters");
  },
  packageOverview: async () => {
    return callApi("package-overview");
  },
  rankOverview: async () => {
    return callApi("rank-overview");
  },
  dashboardExpenses: async () => {
    return callApi("dashboard-expenses");
  },
  endTutorial: async () => {
    return API.post("end-tutorial");
  },
  readnotification: async (id) => {
    return API.patch(`read-notification/${id}`)
  },
  GetRankAchievers: (rank) => {
    const data = useQuery({
      queryKey: ["get-rank-achievers", rank],
      queryFn: () => callApi(`rank-achievers?rank=${rank}`),
      enabled: !!rank
    })
    return data?.data;
  },
  GetRankAchieversWithPagination: async (rank, page = 1, limit = 10) => {
    return callApi(`rank-achievers?rank=${rank}&page=${page}&limit=${limit}`);
  },
  GetCappingAchievers: async (page = 1, limit = 10) => {
    return callApi(`capping-achievers?page=${page}&limit=${limit}`);
  },
    GetPoolBonusUsers: async (page = 1, limit = 10) => {
    return callApi(`pool-bonus-users?page=${page}&limit=${limit}`);
  },
  GetCappingAchieversQuery: () => {
    const data = useQuery({
      queryKey: ["get-capping-achievers"],
      queryFn: () => callApi(`capping-achievers`),
    })
    return data?.data;
  },
  GetReferralPoolAchievers: async (page = 1, limit = 10) => {
    return callApi(`referral-pool-achievers?page=${page}&limit=${limit}`);
  }
};


export default DashboardService;
